import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../styles/styles';
import { BankingDetails } from '../../../../assessment/synopsis/common/banking-details/banking-details';
import { Grid, Typography, withStyles } from '@material-ui/core';
import { LabeledValue } from '../../../../controls/labeled-value';
import { getCodeDescription, GetVerificationWidget } from '../../../../shared-functions';
import { ButtonWrapper } from '../../../../forms';
import { AddPaymentButton } from '../add-payment-item';
import { Payment } from '../../../reducer';

type Props = StyledComponent & {
    bankingDetails: BankingDetails[];
    riskStatus?: string;
    screeningDate?: Date;
    payments: Payment[];
    paymentIndex: number;
};
const raPaymentBankingDetailsView: React.FunctionComponent<Props> = ({
    bankingDetails,
    payments,
    paymentIndex,
}: Props) => {
    if (bankingDetails[0] === null) {
        return null;
    }
    return (
        <React.Fragment>
            {bankingDetails.map((bankingDetails, index) => {
                return (
                    <>
                        <Grid item xs={12} lg={2}>
                            <Typography variant="subtitle1" style={{ fontSize: '20px' }}>
                                Banking details({index + 1})
                            </Typography>
                        </Grid>
                        <Grid item xs={12} container justify="flex-start" key={index}>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Account holder name/company name"
                                    value={`${bankingDetails.accountHoldersInitials || ''} ${
                                        bankingDetails.accountHoldersName || ''
                                    }`}
                                />
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Bank Name"
                                    value={getCodeDescription('bankName', bankingDetails.bankName)}
                                />
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Bank Account Number"
                                    value={bankingDetails.accountNumber}
                                />
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Branch Name"
                                    value={bankingDetails.bankBranch}
                                />
                            </Grid>
                            <Grid item xs={4} lg={1}>
                                <LabeledValue
                                    label="Branch Code"
                                    value={bankingDetails.branchCode}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                lg={2}
                                container
                                justify="flex-start"
                                style={{ marginLeft: '12px' }}
                            >
                                <Grid item xs={12} lg={8}>
                                    <LabeledValue
                                        label="Account Type"
                                        value={bankingDetails.accountType}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <LabeledValue
                                        label="Status"
                                        value={GetVerificationWidget(
                                            bankingDetails.bankAccountStatus || 'Not verified'
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Special Instructions"
                                    value={bankingDetails.specialInstructions || 'None'}
                                />
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                {bankingDetails.investmentIdType === 'Reinvestment' ||
                                    (bankingDetails.investmentIdType === 'CompulsoryAnnuity' && (
                                        <LabeledValue
                                            label="Company Name"
                                            value={`${bankingDetails.companyName || ''}`}
                                        />
                                    ))}
                            </Grid>
                            <Grid item xs={4} lg={4}>
                                {bankingDetails.investmentIdType === 'Reinvestment' ||
                                    (bankingDetails.investmentIdType === 'CompulsoryAnnuity' && (
                                        <LabeledValue
                                            label="Reference number"
                                            value={bankingDetails.companyReference}
                                        />
                                    ))}
                            </Grid>
                            <ButtonWrapper>
                                <AddPaymentButton
                                    payments={payments}
                                    paymentIndex={paymentIndex}
                                    bankIndex={index}
                                />
                            </ButtonWrapper>
                        </Grid>
                    </>
                );
            })}
        </React.Fragment>
    );
};

export const RaPaymentBankingDetailsView = withStyles(styles)(raPaymentBankingDetailsView);
